import React from 'react';
import styled from 'styled-components';

import FlexContainer from 'components/lib/ui/FlexContainer';
import Text from 'components/lib/ui/Text';
import FilterMenuOptionsList from 'components/reports/filters/FilterMenuOptionsList';
import type {
  FilterMenuOption,
  WithPath,
  FilterMenuOptionInput,
  FilterMenuSection,
} from 'components/reports/filters/types';

import { spacing } from 'common/lib/theme/dynamic';

const Row = styled(FlexContainer)`
  align-items: center;
  padding: ${spacing.xxsmall} 0;
`;

type Props = {
  onChangeSelected: (path: string[], selected: boolean) => void;
  onInputChange: (
    path: string[],
    optionId: string,
    input: FilterMenuOptionInput,
    value: unknown,
  ) => void;
  sections: (WithPath<FilterMenuSection> & {
    options: WithPath<FilterMenuOption>[];
  })[];
};

const FilterMenuSearchResults = ({ sections, onChangeSelected, onInputChange }: Props) => (
  <>
    {sections.map(({ id, name, options }) => (
      <React.Fragment key={id}>
        <Row>
          <Text clampLines={1} size="xsmall" weight="medium" color="textLight">
            {name}
          </Text>
        </Row>
        <FilterMenuOptionsList
          options={options}
          onChangeSelected={onChangeSelected}
          onInputChange={onInputChange}
          flat
        />
      </React.Fragment>
    ))}
  </>
);

export default FilterMenuSearchResults;
